const subscribers = new Set();

let nextId = 1;

const normalizeMessage = (value) => {
  if (value instanceof Error) {
    return value.message || 'Something went wrong';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (value && typeof value.message === 'string') {
    return value.message;
  }

  return 'Something went wrong';
};

const notify = (toast) => {
  subscribers.forEach((listener) => listener(toast));
};

export const showToast = (message, type = 'info', duration = 3500) => {
  const toast = {
    id: nextId++,
    message: normalizeMessage(message),
    type,
    duration,
  };

  notify(toast);
  return toast.id;
};

export const toast = {
  success: (message, duration) => showToast(message, 'success', duration),
  error: (message, duration) => showToast(message, 'error', duration),
  warning: (message, duration) => showToast(message, 'warning', duration),
  info: (message, duration) => showToast(message, 'info', duration),
};

export const subscribeToasts = (listener) => {
  subscribers.add(listener);
  return () => subscribers.delete(listener);
};